import React from 'react';
import { NFeStatus, getNFeStatusLabel } from '../../../types/nfe';
import '../nfe.css';

const statusClass: Record<NFeStatus, string> = {
  [NFeStatus.Rascunho]:    'nfe-badge--rascunho',
  [NFeStatus.Completa]:    'nfe-badge--completa',
  [NFeStatus.Processando]: 'nfe-badge--processando',
  [NFeStatus.Autorizada]:  'nfe-badge--autorizada',
  [NFeStatus.Rejeitada]:   'nfe-badge--rejeitada',
  [NFeStatus.Cancelada]:   'nfe-badge--cancelada',
};

interface NFeStatusBadgeProps {
  status: NFeStatus;
  className?: string;
  rejeicaoCstat?: number;
  rejeicaoXMotivo?: string;
}

const NFeStatusBadge: React.FC<NFeStatusBadgeProps> = ({
  status,
  className = '',
  rejeicaoCstat,
  rejeicaoXMotivo,
}) => {
  const tooltip =
    status === NFeStatus.Rejeitada && rejeicaoCstat != null
      ? `${rejeicaoCstat}${rejeicaoXMotivo ? ` – ${rejeicaoXMotivo}` : ''}`
      : undefined;

  return (
    <span
      className={`nfe-badge ${statusClass[status] ?? ''} ${className}`}
      title={tooltip}
      style={tooltip ? { cursor: 'help' } : undefined}
    >
      {getNFeStatusLabel(status)}
    </span>
  );
};

export default NFeStatusBadge;
